import useSWR from "swr";
import axios from "axios";

function useXeroQuote({ shouldFetch = true, quoteId }) {
  const url = `${process.env.REACT_APP_API_URL}/xero/quotes/${quoteId}`;

  return useSWR(shouldFetch ? [url] : null, async ([url]) => {
    const params = new URLSearchParams();
    const { data: quoteData } = await axios.get(`${url}?${params.toString()}`);

    const { Quotes } = quoteData;

    return { quote: Quotes[0] };
  });
}

export default useXeroQuote;
